import React, { useEffect, useState } from "react";
import { BiFilterAlt } from "react-icons/bi";
import interviewStyle from "../Candidate/Candidate interview schedule list/candidateInterviewSchedule.module.scss";
import { decryptedAdminID, MyModal } from "../../utility";
import ModalContainer from "../../components/modal_popup";
import { AiOutlineClose } from "react-icons/ai";
import {
  Autocomplete,
  FormControl,
  Menu,
  MenuItem,
  TextField,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  CandidateFunnelActions,
  CandidateStageAnalyticsActions,
} from "../../redux-store/store";
import { GetAllAdminDetails } from "../../apiServices";

function FunnelFilter() {
  const [showFilter, setShowFilter] = useState(false);
  // const [showRedDot, setshowRedDot] = useState(false);
  const [showCustom, setshowCustom] = useState(false);
  const [adminList, setAdminList] = useState([]);
  const filterDetails = useSelector(
    (state) => state.CandidateFunnelDetails.CandidateFunnelFilter
  );
  const today = new Date();
  const startDate = new Date(today.getFullYear(), today.getMonth(), 1);
  const adminDetailsRole = useSelector((state) => state.adminDetails);
  let isSuperAdmin = adminDetailsRole.roleID == 1;
  const create = useSelector(
    (state) => state.CandidateFunnelDetails.CandidateFunnelFilter.startDate
  );
  const ended = useSelector(
    (state) => state.CandidateFunnelDetails.CandidateFunnelFilter.endDate
  );
  useEffect(() => {
    //console.log(filterDetails, "filterDetails");
  }, [filterDetails]);
  const [dateRange, setDateRange] = useState({
    start: filterDetails.startDate,
    end: filterDetails.endDate,
    dateFilterType: filterDetails.dateFilterType,
  });
  const [validationErrors, setValidationErrors] = useState({
    start: false,
    end: false,
  });
  const initialValues = {
    stage: filterDetails.stage,
    assignTo: isSuperAdmin ? -1 : decryptedAdminID(),
  };
  const [formData, setFormData] = useState(initialValues);
  const Dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  // const handleChangestagee = (event) => {
  //   const selectedStage = event.target.value;
  //   setFormData({ ...formData, stage: selectedStage });
  // };

  const handleClose = (val) => {
    //console.log(val);

    setAnchorEl(null);
  };

  // const handleDateSelect = (val) => {
  //   let selectedOption = val;
  //   const today = new Date();
  //   let endDate = new Date(today);
  //   if (selectedOption === "lastWeek") {
  //     const today = new Date();
  //     const todayDayOfWeek = today.getDay();

  //     const daysToLastMonday = (todayDayOfWeek + 6) % 7;
  //     const lastMonday = new Date(today);
  //     lastMonday.setDate(today.getDate() - daysToLastMonday - 7);

  //     const startDate = new Date(lastMonday);
  //     const endDate = new Date(lastMonday);
  //     endDate.setDate(lastMonday.getDate() + 6);
  //     setDateRange((prev) => ({
  //       ...prev,
  //       dateFilterType: "Last 1 Week",
  //       start: startDate.toISOString().split("T")[0],
  //       end: endDate.toISOString().split("T")[0],
  //     }));

  //     setAnchorEl(null);
  //     //console.log(startDate, endDate);
  //   } else if (selectedOption === "lastTwoWeeks") {
  //     const today = new Date();
  //     const todayDayOfWeek = today.getDay();

  //     const daysToLastMonday = (todayDayOfWeek + 13) % 14;
  //     const lastMonday = new Date(today);
  //     lastMonday.setDate(today.getDate() - daysToLastMonday - 14);

  //     const startDate = new Date(lastMonday);
  //     const endDate = new Date(lastMonday);
  //     endDate.setDate(lastMonday.getDate() + 13);
  //     //console.log(startDate, endDate);
  //     setDateRange((prev) => ({
  //       ...prev,
  //       dateFilterType: "Last 2 Week",
  //       start: startDate.toISOString().split("T")[0],
  //       end: endDate.toISOString().split("T")[0],
  //     }));
  //     setAnchorEl(null);
  //   } else if (selectedOption === "today") {
  //     setDateRange((prev) => ({
  //       ...prev,
  //       dateFilterType: "Today",
  //       start: today.toISOString().split("T")[0],
  //       end: endDate.toISOString().split("T")[0],
  //     }));
  //     setAnchorEl(null);
  //   } else if (selectedOption === "lastMonth") {
  //     const today = new Date();

  //     const startDate = new Date(today.getFullYear(), today.getMonth() - 1, 1);

  //     const endDate = new Date(today.getFullYear(), today.getMonth(), 0);

  //     //console.log(startDate, endDate);
  //     setDateRange((prev) => ({
  //       ...prev,
  //       dateFilterType: "Last Month",
  //       start: startDate.toISOString().split("T")[0],
  //       end: endDate.toISOString().split("T")[0],
  //     }));
  //     setAnchorEl(null);
  //   } else if (selectedOption === "yesterday") {
  //     const today = new Date(); // Assuming today is the current date

  //     // Calculate yesterday's date
  //     const yesterday = new Date(today);
  //     yesterday.setDate(today.getDate() - 1);

  //     // // Set the start time to 12:00 AM
  //     // const startDate = new Date(yesterday);
  //     // startDate.setHours(0, 0, 0, 0);

  //     // // Set the end time to 11:59 PM
  //     // const endDate = new Date(yesterday);
  //     // endDate.setHours(23, 59, 59, 999);

  //     // //console.log(startDate, endDate);
  //     setDateRange((prev) => ({
  //       ...prev,
  //       dateFilterType: "Yesterday",
  //       start: yesterday.toISOString().split("T")[0],
  //       end: yesterday.toISOString().split("T")[0],
  //     }));
  //     setAnchorEl(null);
  //   } else if (selectedOption === "custom") {
  //     setshowCustom(true);
  //     setAnchorEl(null);
  //   }
  // };
  const handleDateSelect = (val) => {
    const today = new Date();
    let startDate, endDate;

    if (val === "currentMonth") {
      // Current month: Start from the 1st of the current month to today's date
      startDate = new Date(today.getFullYear(), today.getMonth(), 1);
      endDate = today;
      setDateRange((prev) => ({
        ...prev,
        dateFilterType: "Current Month",
        start: startDate.toISOString().split("T")[0],
        end: endDate.toISOString().split("T")[0],
      }));
    } else if (val === "lastMonth") {
      // Last month: Start from the 1st of the previous month to the last day of the previous month
      startDate = new Date(today.getFullYear(), today.getMonth() - 1, 1);
      endDate = new Date(today.getFullYear(), today.getMonth(), 0);
      setDateRange((prev) => ({
        ...prev,
        dateFilterType: "Last Month",
        start: startDate.toISOString().split("T")[0],
        end: endDate.toISOString().split("T")[0],
      }));
    } else if (val === "custom") {
      // Custom date range: Show custom date picker
      setshowCustom(true);
    }

    setAnchorEl(null);
  };

  function handleCustomDate(value, type) {
    const val = value.target.value;

    if (type === "startDate") {
      setDateRange((prev) => ({
        ...prev,
        start: val,
        dateFilterType: "custom",
      }));
      setValidationErrors((prev) => ({
        ...prev,
        start: false,
      }));
    } else {
      setDateRange((prev) => ({
        ...prev,
        end: val,
        dateFilterType: "custom",
      }));
      setValidationErrors((prev) => ({
        ...prev,
        end: false,
      }));
    }
  }

  const isFormValid = () => {
    // Implement your validation logic here
    // For example, you can check if both start and end dates are filled
    const isValid = dateRange.start && dateRange.end;

    if (!dateRange.start) {
      setValidationErrors((prev) => ({
        ...prev,
        start: true,
      }));
    }

    if (!dateRange.end) {
      setValidationErrors((prev) => ({
        ...prev,
        end: true,
      }));
    }

    return isValid;
  };

  const handleApply = (e) => {
    e.preventDefault();

    if (isFormValid()) {
      // Your submit logic here
      // Proceed with form submission
      //console.log("Form submitted:", dateRange);
      setValidationErrors({
        start: false,
        end: false,
      });
      setshowCustom(false);
    }
  };
  const handleAdminSelect = (event, value) => {
    setFormData((prevData) => ({
      ...prevData,
      assignTo: value ? value.id : null,
    }));
    //console.log(value.id, "adminValue");
  };
  // const handleAdminSelect = (id) => {
  //   setFormData((prevData) => ({
  //     ...prevData,
  //     assignTo: id,
  //   }));
  // };

  const handleSubmit = (event) => {
    event.preventDefault();

    Dispatch(
      CandidateStageAnalyticsActions.setCandidateStageFilter({
        ...formData,
        assignTo: formData.assignTo,
        startDate: dateRange.start || create,
        endDate: dateRange.end || ended,
        dateFilterType: dateRange.dateFilterType || "",
      })
    );
    //console.log(formData.assignTo, "assignTo");
    // // Check if any filter is applied
    // const isFilterApplied =
    //   interviewFilter.jobId ||
    //   interviewFilter.interviewDate ||
    //   interviewFilter.companyName ||
    //   interviewFilter.contactNumber ||
    //   interviewFilter.candidateMobileNumber ||
    //   interviewFilter.jobCategory ||
    //   interviewFilter.city ||
    //   interviewFilter.area ||
    //   interviewFilter.interviewStatus;

    // // Show the red dot only if a filter is applied
    // if (isFilterApplied) {
    //   setShowRedDot(true);
    // } else {
    //   setShowRedDot(false);
    // }

    setShowFilter(false);
    // //console.log(showFilter, "jhjhsjhdfh");
  };

  useEffect(() => {
    GetAllAdminDetails()
      .then((data) => {
        //console.log(data);
        const activeAdmins = data.filter(
          (item) => !item.Deactived && item.Module !== "Developer"
        );
        setAdminList(activeAdmins);
      })
      .catch(() => {
        alert("Something Went wrong");
      });
  }, []);
  function handleClear(e) {
    e.preventDefault();
    // setFormData({
    //   adminId: decryptedAdminID()
    // });

    setDateRange({
      start: startDate.toISOString().split("T")[0],
      end: new Date().toISOString().split("T")[0],
      dateFilterType: "Current Month",
    });
    setFormData({
      ...formData,
      assignTo: isSuperAdmin ? -1 : decryptedAdminID(),
      stage: 0,
    });
    // setShowRedDot(false);
    Dispatch(
      CandidateStageAnalyticsActions.setCandidateStageFilter({
        ...initialValues,
        startDate: startDate.toISOString().split("T")[0],
        endDate: new Date().toISOString().split("T")[0],
        dateFilterType: "Current Month",
      })
    );
  }
  return (
    <>
      <div className="d-flex align-items-center justify-content-between ms-2 mt-2 mb-2 p-3">
        <div>
          <b className="fs-4">Candidate Funnel</b>
        </div>

        <div>
          {" "}
          <button
            className={`rounded-pill d-flex align-items-center ${interviewStyle.Filterbutton}`}
            variant="contained"
            onClick={() => setShowFilter(true)}
          >
            <BiFilterAlt /> Filter
          </button>
        </div>
        {showFilter && (
          <MyModal>
            <ModalContainer
              zIndex={1001}
              childComponent={
                <div className={""} style={{ width: "400px" }}>
                  <>
                    <div className="d-flex justify-content-end">
                      {/* <h4 className="text-center mb-2">Filter by</h4> */}
                      <h3>
                        <span
                          onClick={() => setShowFilter(false)}
                          className="btn btn-outline-danger"
                          style={{ cursor: "pointer", fontSize: 15 }}
                        >
                          <AiOutlineClose />
                        </span>
                      </h3>
                    </div>
                    <div className="">
                      <form
                        onSubmit={(e) => {
                          handleSubmit(e);
                        }}
                      >
                        {" "}
                        <div className="col-sm-12 mt-2">
                          <FormControl variant="outlined" fullWidth>
                            <TextField
                              label="Created on"
                              id="basic-button"
                              value={`${dateRange.dateFilterType}`}
                              // value={`${dateRange.start} - ${dateRange.end}`}
                              aria-controls={open ? "basic-menu" : undefined}
                              aria-haspopup="true"
                              aria-expanded={open ? "true" : undefined}
                              onClick={handleClick}
                            ></TextField>
                            <Menu
                              id="basic-menu"
                              anchorEl={anchorEl}
                              open={open}
                              onClose={handleClose}
                              MenuListProps={{
                                "aria-labelledby": "basic-button",
                              }}
                            >
                              {/* <MenuItem
                                onClick={() => {
                                  handleDateSelect("today");
                                }}
                                selected
                                style={{ width: "400px" }}
                              >
                                Today
                              </MenuItem>
                              <MenuItem
                                onClick={() => {
                                  handleDateSelect("yesterday");
                                }}
                              >
                                Yesterday
                              </MenuItem>
                              <MenuItem
                                onClick={() => {
                                  handleDateSelect("lastWeek");
                                }}
                              >
                                Last 1 Week
                              </MenuItem>
                              <MenuItem
                                onClick={() => {
                                  handleDateSelect("lastTwoWeeks");
                                }}
                              >
                                Last 2 Week
                              </MenuItem>*/}
                              <MenuItem
                                onClick={() => {
                                  handleDateSelect("currentMonth");
                                }}
                                style={{ width: "400px" }}
                              >
                                Current Month
                              </MenuItem>
                              <MenuItem
                                onClick={() => {
                                  handleDateSelect("lastMonth");
                                }}
                              >
                                Last Month
                              </MenuItem>
                              <MenuItem
                                onClick={() => {
                                  handleDateSelect("custom");
                                }}
                              >
                                Custom Date/Month
                              </MenuItem>
                            </Menu>
                          </FormControl>

                          {showCustom && (
                            <MyModal>
                              <ModalContainer
                                zIndex={1005}
                                childComponent={
                                  <div
                                    style={{
                                      minWidth: "400px",
                                      width: "auto",
                                    }}
                                  >
                                    <>
                                      <div>
                                        <form>
                                          <p className="text-center ">
                                            Select Custom Date{" "}
                                          </p>
                                          <div className="mt-2">
                                            <label htmlFor="start">From</label>
                                            <input
                                              className={`form-control ${
                                                validationErrors.start
                                                  ? "is-invalid"
                                                  : ""
                                              }`}
                                              style={{ width: "100%" }}
                                              type="date"
                                              id="start"
                                              onChange={(value) =>
                                                handleCustomDate(
                                                  value,
                                                  "startDate"
                                                )
                                              }
                                              name="trip-start"
                                              min="2020-01-01"
                                              max={
                                                new Date()
                                                  .toISOString()
                                                  .split("T")[0]
                                              }
                                            />
                                            {validationErrors.start && (
                                              <div className="invalid-feedback">
                                                Start date is required.
                                              </div>
                                            )}
                                          </div>
                                          <div className="mt-2">
                                            <label htmlFor="end">To</label>
                                            <input
                                              className={`form-control ${
                                                validationErrors.end
                                                  ? "is-invalid"
                                                  : ""
                                              }`}
                                              style={{ width: "100%" }}
                                              type="date"
                                              id="end"
                                              onChange={(value) =>
                                                handleCustomDate(
                                                  value,
                                                  "endDate"
                                                )
                                              }
                                              name="trip-end"
                                              min="2020-01-01"
                                              max={
                                                new Date()
                                                  .toISOString()
                                                  .split("T")[0]
                                              }
                                            />
                                            {validationErrors.end && (
                                              <div className="invalid-feedback">
                                                End date is required.
                                              </div>
                                            )}
                                          </div>
                                          <div className="d-flex justify-content-end mt-3 ">
                                            <button
                                              onClick={() => {
                                                setValidationErrors({
                                                  start: false,
                                                  end: false,
                                                });
                                                setshowCustom(false);
                                              }}
                                              style={{
                                                backgroundColor: "#b2261c",
                                              }}
                                              className="btn rounded-pill text-white px-4  me-2"
                                            >
                                              Close
                                            </button>
                                            <button
                                              onClick={handleApply}
                                              // color="primary"
                                              className="btn rounded-pill text-white px-4"
                                              style={{
                                                backgroundColor: "#169C50",
                                              }}
                                            >
                                              Apply
                                            </button>
                                          </div>
                                        </form>
                                      </div>
                                    </>
                                  </div>
                                }
                              />
                            </MyModal>
                          )}
                        </div>
                        {isSuperAdmin && (
                          // <div className="col-sm-12 mt-2">
                          //   <FormControl fullWidth>
                          //     <Autocomplete
                          //       options={[
                          //         { id: -1, userName: "ALL" },
                          //         ...adminList,
                          //       ]}
                          //       getOptionLabel={(option) =>
                          //         option.userName || ""
                          //       }
                          //       value={
                          //         adminList.find(
                          //           (admin) => admin.id === formData.assignTo
                          //         ) ||
                          //         (formData.assignTo === -1
                          //           ? { id: -1, userName: "ALL" }
                          //           : null)
                          //       }
                          //       onChange={(event, newValue) => {
                          //         handleAdminSelect(
                          //           event,
                          //           newValue ? newValue.id : null
                          //         );
                          //       }}
                          //       renderInput={(params) => (
                          //         <TextField
                          //           {...params}
                          //           label="Assigned To"
                          //           variant="outlined"
                          //         />
                          //       )}
                          //     />
                          //   </FormControl>
                          // </div>
                          <div className="col-sm-12 mt-2">
                            <FormControl fullWidth>
                              <Autocomplete
                                options={[
                                  { id: -1, userName: "ALL" },
                                  ...adminList,
                                ]}
                                getOptionLabel={(option) =>
                                  option.userName || ""
                                }
                                value={
                                  adminList.find(
                                    (admin) => admin.id === formData.assignTo
                                  ) ||
                                  (formData.assignTo === -1
                                    ? { id: -1, userName: "ALL" }
                                    : null)
                                }
                                onChange={(event, value) =>
                                  handleAdminSelect(event, value)
                                }
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label="Assigned To"
                                    variant="outlined"
                                  />
                                )}
                              />
                            </FormControl>
                          </div>
                        )}
                        {/* <div className="col-sm-12  mt-3 mb-5">
                          <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">
                              Stage
                            </InputLabel>
                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={formData.stage}
                              label="Stage"
                              onChange={handleChangestagee}
                            >
                              <MenuItem value={0}>overall funnel</MenuItem>
                              <MenuItem value={1}>Lead to Register</MenuItem>
                              <MenuItem value={2}>
                                Scheduled to Attending
                              </MenuItem>
                              <MenuItem value={3}>
                                Offer Rejected to joined
                              </MenuItem>
                            </Select>
                          </FormControl>
                        </div> */}
                        <div className="d-flex flex-row gap-2 justify-content-end mt-2">
                          <button
                            className={`rounded-pill ${interviewStyle.Filterbutton}`}
                            variant="outlined"
                            onClick={(e) => {
                              handleClear(e);
                            }}
                          >
                            Clear All
                          </button>
                          <button
                            className={`rounded-pill ${interviewStyle.search}`}
                            type="submit"
                            variant="contained"
                            sx={{ minWidth: "150px" }}
                          >
                            Search
                          </button>
                        </div>
                      </form>
                    </div>
                  </>
                </div>
              }
            />
          </MyModal>
        )}
      </div>
    </>
  );
}

export default FunnelFilter;
